import React, {createContext, ReactNode, useContext, useEffect, useState} from "react";

interface DeviceContextType{
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
}
const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

interface DeviceProviderProps {
    children: ReactNode;
}

export const DeviceProvider: React.FC<DeviceProviderProps> = ( {children} ) => {
    const [device, setDevice] = useState({
        isMobile: false,
        isTablet: false,
        isDesktop: true
    })
    useEffect( () => {
        //define smartphone media query
        const mobileMql = window.matchMedia("(max-width: 767px)");
        //define tablet media query
        const tabletMql = window.matchMedia("(min-width: 768px) and (max-width: 1023px)");
        //define large screen (pc) media query
        const desktopMql = window.matchMedia("(min-width: 1024px)");
        const updateDevice = () => {
            setDevice({
                isMobile: mobileMql.matches,
                isTablet: tabletMql.matches,
                isDesktop: desktopMql.matches,
            });
        };
        //update device when component is mounted
        updateDevice();
        //add listener event when screen change (Rotate smartphone, change size screen ...ect)
        mobileMql.addEventListener("change", updateDevice);
        tabletMql.addEventListener("change", updateDevice);
        desktopMql.addEventListener("change", updateDevice);
        //clear up when component is unmounted
        return () => {
            mobileMql.removeEventListener("change", updateDevice);
            tabletMql.removeEventListener("change", updateDevice);
            desktopMql.removeEventListener("change", updateDevice);
        };
    }, []);
    return(
        <DeviceContext.Provider value={device}>
            {children}
        </DeviceContext.Provider>
    );
};
export const useDevice = () => {
    const context = useContext(DeviceContext);
    if (!context) {
        throw new Error("useDevice must be used within a DeviceProvider");
    }
    return context;
};